module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0021-01.jpg"
    }
  })])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg21lev1"
    }
  }), _vm._v("FEBRUARY")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg21sec1"
    }
  }), _vm._v("FEBRUARY 1")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have strong and definite emotions. You make a staunch and loyal friend but a bitter enemy. You speak brusquely sometimes, without intention. You should learn to guard against jealousy. Take care that your desire for revenge does not spoil your happiness. You love your home and family life.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg21sec2"
    }
  }), _vm._v("FEBRUARY 2")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a strong personality and much charm and are capable of great good or evil. You like to dream too much and waste valuable time. You are an excellent "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("conversationalist and enjoy culture and refinement. Your work should be active, and you will be very successful if you stick to it.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg22sec1"
    }
  }), _vm._v("FEBRUARY 3")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You should be married early in life to someone born in January, June, or October. You are kind, generous, and good-natured, and you have excellent self-control and keep your own counsel. You are fond of the out-of-doors and love pets and animals.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg22sec2"
    }
  }), _vm._v("FEBRUARY 4")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are very frank and scrupulously honest in your business relations and your love. You are shrewd, have a strong personality, and command respect from all with whom you come in contact. You are fond of children and will have a happy home life.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg22sec3"
    }
  }), _vm._v("FEBRUARY 5")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are a dreamer and inclined to be impractical. Follow through with your ideas and make each one be of merit! Choose your friends for their value, not their connections, or you will bring great unhappiness upon yourself. Be prudent rather than generous in your giving.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "pg23sec1"
    }
  }), _vm._v("FEBRUARY 6")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a keen sense of humor and are witty and fond of fun, though economical and prudent. You are inclined toward sensitiveness, which worries and annoys you. You should practice poise. You are demonstrative and loving, and you should have a very happy marriage.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg23sec2"
    }
  }), _vm._v("FEBRUARY 7")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Be self-confident and trusting, and you will enjoy your home and friends more. You have good judgment and a fine sense of character, but you should not let it dominate your friendships by constantly analyzing them.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg23sec3"
    }
  }), _vm._v("FEBRUARY 8")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("It is easy for you to absorb a universal knowledge without much effort, because of your keen memory. You are very practical and not inclined to take things for granted in your home or business or in love. You are capable of a deep and lasting love, but you hesitate to accept others at their apparent worth.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "pg24sec1"
    }
  }), _vm._v("FEBRUARY 9")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have the potential to be physically strong or physically weak, although neither limits your internal strength. Study yourself and find your inclinations, then practice and apply yourself to them faithfully. You are loyal to your friends and constant in your love.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg24sec2"
    }
  }), _vm._v("FEBRUARY 10")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Practice self-reliance and concentration, and you will be successful, prosperous, and happy. You make and break engagements easily if they interfere with your convenience. You are energetic, kind, and affectionate, and your love will be constant.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg24sec3"
    }
  }), _vm._v("FEBRUARY 11")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Your laziness, indifference, and sometimes cynical manner are drawbacks that you should try desperately to overcome. You have latent talents that could be developed to your advantage. You can be passionate and excitable, but you usually are self-possessed and calm. In love you are not indifferent.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "pg25sec1"
    }
  }), _vm._v("FEBRUARY 12")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Although you are a good and clear reasoner, you are, at a critical time, apt to be impractical. Speculation would be dangerous for you. You are fond of music and art and have some ability with both. You prefer the company of the opposite sex and are quite popular.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg25sec2"
    }
  }), _vm._v("FEBRUARY 13")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a happy and exuberant disposition and a consideration for the rights of others. You like refinement and culture, have good taste, are fond of good literature, and are motivated to learn. In your love affairs, you do not like to stick to one person, but, after marriage, you will be very happy and contented.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg25sec3"
    }
  }), _vm._v("FEBRUARY 14")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("One of your outstanding characteristics is independence. That is a virtue, but it should not be indulged to the point of selfishness. You enjoy praise when it is justly yours and dislike admitting error. You are masterful and very positive with potential lovers but can be indifferent toward those who do not attract your interest.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "pg26sec1"
    }
  }), _vm._v("FEBRUARY 15")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("The satisfaction of your own whims and fancies is paramount in your life. You have talent and ability, but it will not show until some crisis brings it out. Although your interests are few, you thoroughly enjoy them, and your family is very dear to you.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg26sec2"
    }
  }), _vm._v("FEBRUARY 16")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are a born leader, conscientious and careful in all you do. You are fond of art and the finer things in life and cherish integrity and honor. Your love is wholehearted and enduring, for which you will be rewarded.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg26sec3"
    }
  }), _vm._v("FEBRUARY 17")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are fortunate to be born in this month. You have exceptional opportunities in love, business, or a career and can rise to the top. You are most considerate to those dear to you. You love with vigor, and your home life should be ideal.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg26sec4"
    }
  }), _vm._v("FEBRUARY 18")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Because you are blessed with determination, a methodical mind, and good executive ability, you will accomplish "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("much and overcome many difficulties. You are careful, thrifty, and a good planner. You are a favorite among your friends and associates.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg27sec1"
    }
  }), _vm._v("FEBRUARY 19")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are conscientious and reliable and plod along in your work faithfully. You like travel and a change of scene. You are honest and wholehearted in your love, and it will bring joy and contentment to you.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg27sec2"
    }
  }), _vm._v("FEBRUARY 20")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Your passions are deep, and you love and hate with intensity. You lose control of your emotions easily and act hastily when excited, but you quickly regain your better judgment and make amends. You have a great deal of personal pride and like to command.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg27sec3"
    }
  }), _vm._v("FEBRUARY 21")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have excellent reasoning powers but are somewhat critical in your opinions. You are studious, serious, and self-contained, enjoy reading good literature, and like the finer things in life. You will have a pleasant and happy home life.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "pg28sec1"
    }
  }), _vm._v("FEBRUARY 22")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Cultivate self-confidence, self-esteem, and a better outlook on life; you are too apt to be pessimistic. You are capable of great things if you will accept the present happiness and not worry about the future. You are generous to a fault and can love deeply.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg28sec2"
    }
  }), _vm._v("FEBRUARY 23")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You will always enjoy good health and prosperity. You are farsighted, determined, and well balanced. Just and loving, you are generally well liked by all your friends and associates. Your home is very dear to you.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg28sec3"
    }
  }), _vm._v("FEBRUARY 24")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are sweet-tempered, kindly, acquiescent, and retiring. You should choose a mate who is of strong character and robust to complement your quiet temperament. You enjoy serenity and like to be surrounded with luxury.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg28sec4"
    }
  }), _vm._v("FEBRUARY 25")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have a gift of quick and very keen perception, which you should use intelligently and to the greatest advantage. "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("You have a very vivid memory. Your first impressions of people are best. You are impulsive and will marry after a brief courtship.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg29sec1"
    }
  }), _vm._v("FEBRUARY 26")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("When you can forget yourself, you are very entertaining. You are intellectual but inclined to be oversensitive and should cultivate self-confidence. You are careful and considerate, and, although slow in drawing conclusions, you are unusually accurate in your judgment. You are affectionate and loving.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg29sec2"
    }
  }), _vm._v("FEBRUARY 27")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You have an acquisitive faculty that, if cultivated, will make you very successful. You are restless but methodical in your habits and fond of responsibility, and you like to be a leader. You are devoted to your family and have their love and respect.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg29sec3"
    }
  }), _vm._v("FEBRUARY 28")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are spiritually inclined and your interest in religion is absorbing, but your analytical mind will not let you accept any doctrine or follow any sect without understanding it. "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("You are loving and sincere and fond of travel and outdoor sports.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "pg30sec1"
    }
  }), _vm._v("FEBRUARY 29")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("You are gentle, sympathetic, and considerate of others. You are easily influenced and like a change of environment. Your love of literature colors your conversation so that you are in great social demand. You can readily adapt yourself to any circumstances. You like attention, and your love is true.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6412d568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08-chapter02.vue
// module id = 78
// module chunks = 0